import { ServiceData } from "../data/servicesData";

export const generateOrganizationSchema = () => ({
  "@context": "https://schema.org",
  "@type": "LocalBusiness",
  name: "Brin's Handyman Services",
  description:
    "Professional handyman services in Ottawa and surrounding areas. We offer home repairs, painting, plumbing, carpentry, drywall installation, and furniture repairs. For specialized work requiring licensed professionals, we collaborate with certified contractors.",
  url: "https://brinshandymanservices.ca",
  logo: "https://brinshandymanservices.ca/logo512.png",
  image: "https://brinshandymanservices.ca/logo512.png",
  telephone: "+1-613-555-0123",
  email: "info@brinshandymanservices.ca",
  address: {
    "@type": "PostalAddress",
    streetAddress: "Ottawa Area",
    addressLocality: "Ottawa",
    addressRegion: "Ontario",
    postalCode: "K1P",
    addressCountry: "CA",
  },
  geo: {
    "@type": "GeoCoordinates",
    latitude: 45.4215,
    longitude: -75.6972,
  },
  areaServed: {
    "@type": "City",
    name: "Ottawa",
  },
  serviceArea: {
    "@type": "GeoCircle",
    geoMidpoint: {
      "@type": "GeoCoordinates",
      latitude: 45.4215,
      longitude: -75.6972,
    },
    geoRadius: "50000",
  },
  openingHours: "Mo-Su 08:00-18:00",
  priceRange: "$$",
  paymentAccepted: ["Cash", "Credit Card", "Debit Card", "E-transfer"],
  currenciesAccepted: "CAD",
  sameAs: [
    "https://www.facebook.com/brinshandyman",
    "https://www.instagram.com/brinshandyman",
  ],
});

export const generateServiceSchema = (service: ServiceData) => ({
  "@context": "https://schema.org",
  "@type": "Service",
  name: service.name,
  description: service.description,
  url: `https://brinshandymanservices.ca/service/${service.slug}`,
  image: `https://brinshandymanservices.ca${service.mainImageUrl}`,
  provider: {
    "@type": "LocalBusiness",
    name: "Brin's Handyman Services",
    url: "https://brinshandymanservices.ca",
  },
  serviceType: service.name,
  areaServed: {
    "@type": "City",
    name: "Ottawa",
  },
  hasOfferCatalog: {
    "@type": "OfferCatalog",
    name: `${service.name} Services`,
    itemListElement: service.features.map((feature, index) => ({
      "@type": "Offer",
      itemOffered: {
        "@type": "Service",
        name: feature,
      },
    })),
  },
});

export const generateWebPageSchema = (
  title: string,
  description: string,
  url: string
) => ({
  "@context": "https://schema.org",
  "@type": "WebPage",
  name: title,
  description: description,
  url: url,
  mainEntity: {
    "@type": "LocalBusiness",
    name: "Brin's Handyman Services",
  },
});

export const generateBreadcrumbSchema = (
  breadcrumbs: Array<{ name: string; url: string }>
) => ({
  "@context": "https://schema.org",
  "@type": "BreadcrumbList",
  itemListElement: breadcrumbs.map((crumb, index) => ({
    "@type": "ListItem",
    position: index + 1,
    name: crumb.name,
    item: crumb.url,
  })),
});

export const generateFAQSchema = (
  faqs: Array<{ question: string; answer: string }>
) => ({
  "@context": "https://schema.org",
  "@type": "FAQPage",
  mainEntity: faqs.map((faq) => ({
    "@type": "Question",
    name: faq.question,
    acceptedAnswer: {
      "@type": "Answer",
      text: faq.answer,
    },
  })),
});
